// BEAM design tokens — spacing, radius, elevation, layout, motion. v1 "Blueprint".
import { Platform, type ViewStyle } from 'react-native';

// 4-pt base scale.
export const spacing = {
  xs: 4, sm: 8, md: 12, lg: 16, xl: 20, '2xl': 24, '3xl': 32, '4xl': 40,
} as const;

export const radius = {
  sm: 8,    // inputs, small tiles
  md: 12,   // buttons, list rows
  lg: 16,   // cards, sheets
  xl: 22,   // app icon
  pill: 999 // badges
} as const;

// The single card/sheet elevation. Shadows stay soft — strong shadows hurt
// legibility in bright field light, so lists are flat (border only).
export const shadow: { card: ViewStyle } = {
  card: Platform.select<ViewStyle>({
    ios: { shadowColor: '#101828', shadowOpacity: 0.06, shadowRadius: 18, shadowOffset: { width: 0, height: 8 } },
    android: { elevation: 2 },
    default: {},
  })!,
};

export const layout = {
  screenPadding: spacing.lg, // 16 — horizontal screen gutter
  minTapTarget: 44,          // iOS/Android minimum touch size
  fieldHeight: 44,
  hairline: 1,
  focusRingWidth: 3,
  // Web ergonomics (W5). On wide viewports content is centered at contentMaxWidth instead of
  // stretching full-bleed; wideBreakpoint marks the tablet/desktop layout threshold. On phones
  // (width < these), they have no effect — native rendering is unchanged.
  contentMaxWidth: 880,
  wideBreakpoint: 900,
} as const;

export const motion = { fast: 150, base: 220, slow: 320 } as const;
